module.exports = __webpack_public_path__ + "static/media/21ECLAC32.69b2a8ff.jpg";